import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch, connect } from "react-redux";
import profile0 from "../../assets/profile0.jpg"
import StatusTag from "../common/StatusTag";
import Info from "../common/Info";
// import IconTick from "../iconComponents/IconTick";

export function PartyView(props) {

    const contract = useSelector(state => state.contract.contract);

    const [person, setPerson] = useState(null);

    const noPerson = {
        first_name: "",
        last_name: "",
        email: "",
        user_icon_path: profile0,
        status: null
    }

    useEffect(() => {
        if (contract[props.role] && contract[props.role] !== undefined) {
            if (props.role === "PCA" || props.role === "VCA" || props.role === "AP" || props.role === "AR") {
                setPerson(contract[props.role]);
            } 
        } else if (props.role.startsWith("APP")) {
            let approval_level_index = props.role.split("APP")[1] - 1;
            if (contract.approval_levels[approval_level_index]){
                if (contract.approval_levels[approval_level_index].parties) {
                    if (contract.approval_levels[approval_level_index].parties[0]){
                        if (contract.approval_levels[approval_level_index].parties[0].email) {
                            setPerson(contract.approval_levels[approval_level_index].parties[0]);
                        } else setPerson(noPerson);
                    } else setPerson(noPerson);
                } else setPerson(noPerson);
            } else setPerson(noPerson);
        } else setPerson(noPerson);
    }, [contract])

    // useEffect(() => {
    //     console.log("props.role :")
    //     console.log(props.role)
    //     console.log("person: ")
    //     console.log(person)
    // }, [person])



    return (
        <div className="user-card">
            {person &&
                <>
                    <img className="image-xs gap-right-s crop" src={person.user_icon_path} alt="" role="presentation" ></img>
                    <div style={{ flex: 1 }} className="flex-column">
                        <div className="flex-row" style={{ alignItems: "center" }}>
                            <h3 className="iblock content2 heavy-grey" style={{ alignItems: "center" }}>{props.title}</h3>
                            <Info heading={props.title} className="gap-right-xs" size="14" >{props.roleInfo}</Info>
                            {person.status === "Active" ? <StatusTag status={"Confirmed"} /> : (person.status === "Pending" ? <StatusTag status={"Invited"} /> : <></>)}
                            {/* {person.status === "Active" ? <IconTick height="10px" pathClass="ta-fill" /> : (person.status === "Pending" ? <StatusTag status={"Invited"} /> : <></>)} */}
                        </div>
                        <div className="user-card-text">
                            {person.email ?
                                <>
                                    <h3 className="iblock multiline content1 heavy gap-right-xxs">{!person.first_name ? person.email : `${person.first_name} ${person.last_name}`}</h3>
                                    <h3 className="iblock multiline content1 light-black gap-right-xxs">{!person.first_name ? '' : person.email}</h3>
                                </>
                                : <h4 className="iblock multiline content2 light">To be added by {props.role === "VCA" || props.role === "AR" ? "Vendor" : "Purchaser"}</h4>
                            }
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

const mapState = (state) => ({});

export default connect(mapState)(PartyView);